module.exports = __webpack_public_path__ + "static/media/item__food-2.5eaacc85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/item__food-2.png
// module id = 2327
// module chunks = 0